/**
 * Validadores comuns do domínio
 */

export const isValidEmail = (email: string | null | undefined): boolean => {
    if (!email || email.trim() === '') return true; // Aceita vazio se opcional
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const isValidPhone = (phone: string | null | undefined): boolean => {
    if (!phone || phone.trim() === '') return true; // Aceita vazio
    const cleanPhone = phone.replace(/\D/g, '');
    return cleanPhone.length >= 5; // Relaxado
};
